export default function TickCircleIcon() {
  return (
    <>
      <g id='tick-circle'>
        <g id='vuesax/bulk/tick-circle'>
          <g id='tick-circle_2'>
            <path
              id='Vector'
              d='M40 73.3337C58.4095 73.3337 73.3333 58.4098 73.3333 40.0003C73.3333 21.5908 58.4095 6.66699 40 6.66699C21.5905 6.66699 6.66663 21.5908 6.66663 40.0003C6.66663 58.4098 21.5905 73.3337 40 73.3337Z'
              fill='#FBF3F2'
            />
            <path
              id='Vector_2'
              d='M35.2667 51.9337C34.6 51.9337 33.9667 51.667 33.5 51.2003L24.0667 41.767C23.1 40.8003 23.1 39.2003 24.0667 38.2337C25.0333 37.267 26.6333 37.267 27.6 38.2337L35.2667 45.9003L52.4 28.767C53.3667 27.8003 54.9667 27.8003 55.9333 28.767C56.9 29.7337 56.9 31.3337 55.9333 32.3003L37.0333 51.2003C36.5667 51.667 35.9333 51.9337 35.2667 51.9337Z'
              fill='#A0383F'
            />
          </g>
        </g>
      </g>
    </>
  );
}
